import { memo } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Scrollbar from 'src/components/scrollbar';
import { useTheme } from '@mui/system';
import NavList from './nav-list';

import { NavUl, NavLi } from '../styles';
import { navSectionClasses } from '../classes';
import { navSectionCssVars } from '../css-vars';



function NavSectionHorizontal({
  sx,
  data,
  render,
  slotProps,
  enabledRootRedirect,
  cssVars: overridesVars,
  ...other
}) {
  const theme = useTheme();

  if (!data || data.length === 0) {
    return null; // Return null if there's no data
  }

  const cssVars = {
    ...navSectionCssVars.horizontal(theme),
    ...overridesVars,
  };

  return (
    <Scrollbar
      sx={{ height: 1 }}
      slotProps={{
        content: { height: 1, display: 'flex', alignItems: 'center' },
      }}
    >
      <Stack
        component="nav"
        id="nav-section-horizontal"
        direction="row"
        alignItems="center"
        className={navSectionClasses.horizontal.root}
        sx={{
          ...cssVars,
          mx: 'auto',
          height: 1,
          minHeight: 'var(--nav-height)',
          ...sx,
        }}
        {...other}
      >
        <NavUl sx={{ flexDirection: 'row', gap: 'var(--nav-item-gap)' }}>
          {data.map((group, index) => (
            <Group
              key={group.subheader || index}
              items={group.items}
              render={render}
              cssVars={cssVars}
              slotProps={slotProps}
              enabledRootRedirect={enabledRootRedirect}
            />
          ))}
        </NavUl>
      </Stack>
    </Scrollbar>
  );
}

NavSectionHorizontal.propTypes = {
  data: PropTypes.array,
  render: PropTypes.func,
  slotProps: PropTypes.object,
  enabledRootRedirect: PropTypes.bool,
  cssVars: PropTypes.object,
  sx: PropTypes.object,
};

export default memo(NavSectionHorizontal);

function Group({ items, render, slotProps, enabledRootRedirect, cssVars }) {
  return (
    <NavLi>
      <NavUl sx={{ flexDirection: 'row', gap: 'var(--nav-item-gap)' }}>
        {items.map((list) => (
          <NavList
            key={list.title}
            depth={1}
            data={list}
            render={render}
            cssVars={cssVars}
            slotProps={slotProps}
            enabledRootRedirect={enabledRootRedirect}
            user={slotProps.user}
            selectedTenant={slotProps.selectedTenant}
          />
        ))}
      </NavUl>
    </NavLi>
  );
}

Group.propTypes = {
  items: PropTypes.array,
  render: PropTypes.func,
  slotProps: PropTypes.object,
  enabledRootRedirect: PropTypes.bool,
  cssVars: PropTypes.object,
};
